import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";

// Editable "Actual Delivered" field for a single order item.
// Used by both the Admin Orders panel and the Co-Admin Deliveries view.
// onSave receives the parsed value (number) or null when cleared.
export function DeliveredCell({ item, unit, disabled, onSave, testid }) {
  const stored = item.delivered_kg === null || item.delivered_kg === undefined ? "" : String(item.delivered_kg);
  const [val, setVal] = useState(stored);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setVal(item.delivered_kg === null || item.delivered_kg === undefined ? "" : String(item.delivered_kg));
  }, [item.delivered_kg]);

  const commit = async () => {
    const raw = val.trim();
    const parsed = raw === "" ? null : parseFloat(raw);
    if (raw !== "" && (isNaN(parsed) || parsed < 0)) {
      toast.error("Enter a valid delivered quantity");
      setVal(stored);
      return;
    }
    const cur = item.delivered_kg === null || item.delivered_kg === undefined ? null : item.delivered_kg;
    if (parsed === cur) return;
    setSaving(true);
    try {
      await onSave(parsed);
      toast.success(parsed === null ? "Delivered quantity cleared" : "Delivered quantity saved");
    } catch (e) {
      toast.error("Could not save delivered quantity");
      setVal(stored);
    } finally {
      setSaving(false);
    }
  };

  const by = item.delivered_by;
  return (
    <div className="flex flex-col items-end gap-0.5 shrink-0">
      <div className="flex items-center gap-1">
        <Input
          type="number"
          step="0.01"
          min="0"
          inputMode="decimal"
          value={val}
          disabled={disabled || saving}
          onChange={(e) => setVal(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
          data-testid={testid}
          placeholder="—"
          title="Actual delivered quantity"
          className="w-20 h-7 rounded-none bg-[#141414] border-white/15 text-white text-right tabular text-sm px-2 focus-visible:ring-2 focus-visible:ring-white/30 disabled:opacity-40"
        />
        <span className="text-[10px] text-white/40 w-6">{unit}</span>
      </div>
      {by && (
        <span
          data-testid={`${testid}-by`}
          className={`text-[9px] uppercase tracking-wider ${by === "coadmin" ? "text-purple-300" : "text-white/40"}`}
        >
          by {by === "coadmin" ? "Co-Admin" : "Admin"}
        </span>
      )}
    </div>
  );
}
